export default __webpack_public_path__ + "static/media/question-circle-fill.8776ff66.svg";